import { createSvgIcon } from "@mui/material/utils";

export const ExclamationCircleColored = createSvgIcon(
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 20C7.8476 20 5.304 18.9461 3.429 17.071C1.554 15.1959 0.5 12.6522 0.5 10C0.5 7.3478 1.5539 4.804 3.429 2.929C5.3041 1.054 7.8478 0 10.5 0C13.1522 0 15.696 1.0539 17.571 2.929C19.446 4.8041 20.5 7.3478 20.5 10C20.4969 12.6516 19.4422 15.193 17.568 17.068C15.693 18.9422 13.1516 19.997 10.5 20ZM10.5 1.468C8.2376 1.468 6.0672 2.36722 4.4672 3.9672C2.8672 5.56718 1.968 7.7376 1.968 10C1.968 12.2624 2.86722 14.4328 4.4672 16.0328C6.06718 17.6328 8.2376 18.532 10.5 18.532C12.7624 18.532 14.9328 17.6328 16.5328 16.0328C18.1328 14.4328 19.032 12.2624 19.032 10C19.0297 7.7382 18.1297 5.5696 16.5304 3.9696C14.9304 2.37038 12.7616 1.4704 10.5 1.468Z"
      fill="#5048E5"
    />
    <path
      d="M10.5001 8.71582C10.9563 8.71582 11.3259 9.17206 11.3259 9.5416V14.8626C11.3259 15.3188 10.9563 15.6884 10.5001 15.6884C10.0439 15.6884 9.67432 15.2321 9.67432 14.8626V9.5416C9.67432 9.08536 10.0439 8.71582 10.5001 8.71582Z"
      fill="#5048E5"
    />
    <path
      d="M11.693 5.96347C11.693 6.62207 11.1587 7.15643 10.5001 7.15643C9.84151 7.15643 9.30713 6.62205 9.30713 5.96347C9.30713 5.30487 9.84151 4.77051 10.5001 4.77051C11.1587 4.77051 11.693 5.30489 11.693 5.96347Z"
      fill="#5048E5"
    />
  </svg>,
  "ExclamationCircleColored"
);
